import React, {useCallback} from 'react';
import {useBalloonEventsOptions} from '../contexts/EmbedOptions';
import {getFrontendUrl} from 'ts-core';
import {FiEdit} from "react-icons/fi";
import {useTranslations, useUser} from "react-ui";
import {useCreatorModalSafe} from '../contexts/CreatorModal';
import {useBalloonEventsDataSafe} from '../contexts/EventData';

interface EditButtonProps {
    slug: string;
    canEdit?: boolean;
}

export function EditButton({slug, canEdit}: EditButtonProps) {
    if (canEdit === false) {
        return null;
    }
    return <EditButtonContent slug={slug} />;
}

function EditButtonContent({slug}: { slug: string }) {
    const {creatorURL} = useBalloonEventsOptions();
    const {translated} = useTranslations();
    const {requiresUser} = useUser();
    const creatorModal = useCreatorModalSafe();
    const eventData = useBalloonEventsDataSafe();

    const fallbackToNewTab = useCallback(() => {
        let url: string;
        if (creatorURL) {
            const urlObj = new URL(creatorURL);
            urlObj.searchParams.set('edit', slug);
            url = urlObj.toString();
        } else {
            const frontendBaseUrl = getFrontendUrl();
            url = `${frontendBaseUrl}/create?edit=${slug}`;
        }
        window.open(url, '_blank');
    }, [creatorURL, slug]);

    const onClick = useCallback(() => {
        if (creatorModal) {
            requiresUser({
                callback: () => {
                    const cachedEvent = eventData?.getEvent(slug);
                    creatorModal.openCreatorForEdit(slug, cachedEvent ?? undefined);
                }
            });
        } else {
            fallbackToNewTab();
        }
    }, [creatorModal, eventData, slug, requiresUser, fallbackToNewTab]);

    return (
        <button
            onClick={onClick}
            className={"flex justify-center items-center w-[36px] h-[36px] text-balloon hover:text-white bg-transparent hover:bg-balloon rounded-full p-2"}
            aria-label={translated("edit")}
            title={translated("edit")}
        ><FiEdit size={20}/></button>
    );
}
